"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Check } from "lucide-react";
export default function PricingPackages() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const pricingTiers = [{
    id: 1,
    title: "Essential",
    price: "SR 1,699",
    period: "Starting from",
    features: ["Half-day shoot (4 hours)", "Basic editing & color grading", "20 edited photos or 1 video (up to 2 min)", "Online delivery", "1 round of revisions"]
  }, {
    id: 2,
    title: "Professional",
    price: "SR 2,299",
    period: "Starting from",
    features: ["Full-day shoot (8 hours)", "Advanced editing & color grading", "50 edited photos or 1 video (up to 5 min)", "Cinematic effects & motion graphics", "2 rounds of revisions", "Priority support"]
  }, {
    id: 3,
    title: "Premium",
    price: "SR 3,999",
    period: "Starting from",
    features: ["Multi-day shoot (up to 3 days)", "Premium editing & post-production", "Unlimited edited photos & videos", "Full cinematic suite with sound design", "Unlimited revisions", "Dedicated project manager", "Rush delivery available"]
  }];
  return <section id="pricing-packages" className="py-24 px-4 bg-muted-light-background" ref={containerRef}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className={`font-display text-4xl md:text-5xl font-bold text-foreground mb-4 transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Pricing & Packages
          </h2>
          <p className={`text-lg text-muted-foreground max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            Choose the perfect package for your project. Custom quotes available for unique requirements.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pricingTiers.map((tier, i) => <div key={tier.id} data-index={i} className={`transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: `${150 * (i + 1)}ms`
        }}>
              <Card className="h-full border-2 border-accent/30 shadow-medium hover:shadow-strong hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <CardHeader className="text-center pb-8">
                  <CardTitle className="text-2xl font-display font-bold text-foreground mb-2">
                    {tier.title}
                  </CardTitle>
                  <div className="mt-4">
                    <p className="text-sm text-muted-foreground">{tier.period}</p>
                    <p className="text-4xl font-bold text-accent mt-2">{tier.price}</p>
                  </div>
                </CardHeader>
                <CardContent className="space-y-4 pb-8">
                  <ul className="space-y-3">
                    {tier.features.map((feature, idx) => <li key={idx} data-index={idx} className="flex items-start gap-3">
                        <Check className="size-5 text-accent shrink-0 mt-0.5" />
                        <span className="text-sm text-foreground-muted-light">{feature}</span>
                      </li>)}
                  </ul>
                </CardContent>
                <CardFooter className="pt-6 border-t">
                  <Button className="w-full btn-primary" size="lg">
                    Get Started
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-6">
            Need something custom? We can tailor a package specifically for your needs.
          </p>
          <Button variant="outline" size="lg" className="border-2 border-accent text-accent hover:bg-accent hover:text-foreground-accent">
            Request Custom Quote
          </Button>
        </div>
      </div>
    </section>;
}